import React from 'react';
import { Input, AutoComplete } from 'antd';
import ABSIcon from '../../../ABSIcon';
import { ISearchResult } from './../serachHelper';
import routeConfig from '../../../../abs/config/routeConfig';
import commonUtils from '../../../../utils/commonUtils';
import classnames from 'classnames';
import ABSAvatar from '../../../ABSAvatar';
import './index.less';
import ABSMessage from '../../../ABSMessage';

const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;

export interface IABSSearchBarProps {
  placeholder?: string;
  // value?: string;
  size: 'small' | 'large';
  onSearch?: (keyword: string) => void;
  onKeyDown?: (keyword: string) => void;
  onSelect?: (value: any, option: Object) => any;
  className?: string;
  dropdownClassName?: string;
  isSearch?: boolean; // 是否进行搜索，（默认true）
  // isKeyDown?: boolean; // 是否触发键盘Enter事件, (默认false)
  loading: boolean;
  keyword: string;
  isOpen: boolean;
  results: Array<ISearchResult>;
  onFocus: (e: any) => any;
  onBlur: (e: any) => any;
}

export interface IABSSearchBarState {}

class ABSGlobalSearchView extends React.Component<IABSSearchBarProps, IABSSearchBarState> {
  // 跳转搜索结果页面
  onGoMore = (keyword: string): any => {
    if (keyword === '') {
      ABSMessage.warning('请输入要查询的内容！');
      return;
    }
    window.location.href = `${routeConfig.search}?keyword=${keyword}`;
  }

  render() {
    const { size, onSearch, onSelect, className, placeholder, 
      results, isOpen, loading, keyword, onFocus, onBlur } = this.props;
    let basicClassName = 'abs-search ';
    basicClassName += size === 'large' ? 'abs-search-large' : 'abs-search-small';
    const mergeClassName = classnames(basicClassName, className);

    const inputSuffix = loading ? <ABSIcon isAnt={true} type="loading" />
      : <ABSIcon type="search" onClick={onSearch ? () => onSearch(keyword) : this.onGoMore(keyword)} />;

    const options: any = results && results.length > 0 ? results.map(group => (
      <OptGroup
        key={group.title}
        label={group.title}
      >
        {group.children.map(opt => (
          <Option key={opt.url} value={opt.id} title={keyword}>
            {
              opt.avatarUrl ?
              <ABSAvatar size="default" imageUrl={opt.avatarUrl} className="abs-search-expert-avatar"/> : null
            }
            <div style={{float: 'left'}}>
              <div className="abs-select-dropdown-menu-item-title">{opt.title}</div>
              <div className="abs-select-dropdown-menu-item-description">{opt.description}</div>
            </div>
          </Option>
        ))}
      </OptGroup>
    )).concat([
      (
        <Option key={`${routeConfig.search}?keyword=${keyword}`} title={keyword} className="abs-select-dropdown-menu-item-show-more">
          查看更多<ABSIcon type="direction-right" />
        </Option>
      ),
    ]) : [
        (
          <Option disabled={true} key="all" className="abs-select-dropdown-menu-item-no-data">
            没有结果。请尝试简化关键词，例如 “碧桂园 47期”。
          </Option>
        )];
    const content: any = <Input suffix={inputSuffix} onFocus={(e) => onFocus(e)} onBlur={(e) => onBlur(e)} />;
    return (
      <AutoComplete
        className={mergeClassName}
        dropdownClassName="abs-search-dropdown"
        dataSource={options}
        placeholder={placeholder}
        optionLabelProp="title"
        open={isOpen}
        defaultActiveFirstOption={false}
        defaultValue={commonUtils.getParams().keyword}
        onSelect={onSelect}
        onSearch={onSearch}
      >
        {content}
      </AutoComplete>
    );
  }
}

export default ABSGlobalSearchView;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSearch/GlobalSearch/GlobalSearchView/index.tsx